// Auto-generated normalizer for table: CuestionarioRespuestaOpcionMultiple
export function cuestionarioRespuestaOpcionMultipleNormalize(row) {
  return {
    idRespuestaOpcionMultiple: row.idRespuestaOpcionMultiple ?? row.IdRespuestaOpcionMultiple ?? row['IdRespuestaOpcionMultiple'] ?? 0,
    idCuestionarioPreguntas: row.idCuestionarioPreguntas ?? row.IdCuestionarioPreguntas ?? row['IdCuestionarioPreguntas'] ?? 0,
    permiteMultiple: row.permiteMultiple ?? row.PermiteMultiple ?? row['PermiteMultiple'] ?? false,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
